/**
 * Amounts (in cents) of the example payment used to check that a typology is balanced.
 * The net to pay depends on the company settings and is set by the comparison table.
 */
export const EXAMPLE_VARIABLES = {
    distributorContributions: 1650,
    vat10: 15000,
    vat92: 13800,
    vatIntracom: 14300,
    totalContributions: 25695,
    socialContributions: 24045,
    foreignWithholding: 30000,
    previousPositiveBalance: 50000,
    grossDuty: 150000,
    totalIrcecPublisher: 4500,
    totalIrcecBeneficiary: 15000,
    // Detail of distributorContributions, so a detailed typology balances the same way
    distributorContribution: 1500,
    distributorTraining: 150,
    // Detail of socialContributions
    oldAgeUncapped: 600,
    oldAgeCapped: 9150,
    csgDeductible: 9750,
    csgNonDeductible: 3150,
    crds: 870,
    professionalTraining: 525,
};
